{
  "common": {
    "loading": "กำลังโหลด…",
    "cancel": "ยกเลิก",
    "close": "ปิด"
  },
  "themes": {
    "title": "หน้าตาเว็บไซต์",
    "intro": "เปลี่ยนหน้าตาร้านออนไลน์ การแก้ไขจะบันทึกเป็นร่างก่อน ลูกค้าจะเห็นหลังจากกดเผยแพร่เท่านั้น",
    "status_live": "ใช้งานอยู่บนเว็บ",
    "status_draft": "ร่าง",
    "updated": "แก้ไขล่าสุด {{when}}",
    "edit": "แก้ไข",
    "duplicate": "ทำสำเนา",
    "make_live": "ตั้งเป็นหลัก",
    "make_live_title": "ใช้ “{{name}}” บนเว็บไหม?",
    "make_live_body": "ลูกค้าจะเห็นหน้าตานี้ภายในไม่กี่วินาที หน้าตาเดิมยังเก็บไว้และเปลี่ยนกลับได้",
    "copy_name": "สำเนาของ {{name}}",
    "copied": "สร้างสำเนา “{{name}}” เป็นร่างแล้ว",
    "published": "เว็บใช้หน้าตานี้แล้ว",
    "action_failed": "ทำไม่สำเร็จ ลองใหม่อีกครั้ง",
    "load_failed": "โหลดรายการหน้าตาเว็บไม่ได้ ลองใหม่อีกครั้ง",
    "empty": "ยังไม่มีหน้าตาเว็บ"
  },
  "pages": {
    "index": "หน้าแรก",
    "product": "หน้าสินค้า",
    "collection": "หน้าหมวด",
    "list_collections": "รวมหมวดทั้งหมด",
    "search": "ผลการค้นหา",
    "page": "หน้าข้อมูล",
    "policy": "หน้านโยบายร้าน",
    "cart": "ตะกร้า",
    "checkout": "ชำระเงิน",
    "tracking": "ติดตามคำสั่งซื้อ",
    "404": "ไม่พบหน้า",
    "password": "หน้าปิดร้านชั่วคราว",
    "with_suffix": "{{page}} — {{suffix}}"
  },
  "toolbar": {
    "label": "เครื่องมือแก้ไข",
    "back": "กลับ",
    "page": "หน้าที่จะแก้",
    "device": "ขนาดตัวอย่าง",
    "device_mobile": "มือถือ ({{width}} px)",
    "device_tablet": "แท็บเล็ต ({{width}} px)",
    "device_desktop": "คอมพิวเตอร์ ({{width}} px)",
    "preview_language": "ภาษาของตัวอย่าง",
    "undo": "ย้อนกลับ",
    "redo": "ทำซ้ำ",
    "save_draft": "บันทึกร่าง",
    "publish": "เผยแพร่",
    "publishing": "กำลังเผยแพร่…",
    "publish_not_allowed": "เฉพาะเจ้าของร้านหรือผู้จัดการเท่านั้นที่เผยแพร่ได้",
    "sample_product": "สินค้าตัวอย่าง",
    "sample_collection": "หมวดตัวอย่าง",
    "sample_none": "เลือก…",
    "search_product": "ค้นหาสินค้า",
    "search_collection": "ค้นหาหมวด",
    "sample_error": "ตอนนี้ค้นหาไม่ได้",
    "sample_empty": "ไม่พบ",
    "sample_count_other": "{{count}} ชิ้น",
    "history": "ประวัติ",
    "request_publish": "ส่งให้ผู้จัดการเผยแพร่",
    "theme_settings": "ตั้งค่าทั้งเว็บ"
  },
  "save": {
    "idle": "ยังไม่มีการแก้ไข",
    "pending": "มีการแก้ไขที่ยังไม่บันทึก",
    "saving": "กำลังบันทึก…",
    "saved": "บันทึกแล้ว",
    "failed": "บันทึกไม่สำเร็จ",
    "invalid": "ยังไม่บันทึก — แก้จุดที่มีเครื่องหมายก่อน",
    "conflict": "มีคนอื่นแก้หน้านี้อยู่",
    "retry": "ลองใหม่"
  },
  "tree": {
    "label": "ส่วนต่างๆ ของหน้า",
    "area": {
      "header": "ส่วนหัวของเว็บ",
      "template": "เนื้อหาหน้า",
      "footer": "ส่วนท้ายของเว็บ",
      "overlay": "หน้าต่างลอย"
    },
    "group": {
      "announcement": "แถบประกาศ",
      "header": "โลโก้และเมนู",
      "footer": "ส่วนท้ายของเว็บ",
      "overlay": "หน้าต่างลอย"
    },
    "empty": "ยังไม่มีอะไร",
    "add_section": "เพิ่มส่วน",
    "add_section_to": "เพิ่มส่วนใน{{group}}",
    "actions_for": "คำสั่งของ {{name}}",
    "move_up": "เลื่อน {{name}} ขึ้น",
    "move_down": "เลื่อน {{name}} ลง",
    "cannot_move_up": "อยู่บนสุดแล้ว",
    "cannot_move_down": "อยู่ล่างสุดแล้ว",
    "show": "แสดง {{name}} อีกครั้ง",
    "hide": "ซ่อน {{name}}",
    "duplicate": "ทำสำเนา {{name}}",
    "delete": "ลบ {{name}}",
    "drag": "ลากเพื่อย้าย {{name}}",
    "expand": "แสดงชิ้นส่วนของ {{name}}",
    "collapse": "ซ่อนชิ้นส่วนของ {{name}}",
    "hidden": "ซ่อนอยู่",
    "issue_count_other": "ปัญหา {{count}} จุด",
    "unknown_section": "ส่วนที่ไม่รู้จัก ({{type}})",
    "unknown_block": "ชิ้นส่วนที่ไม่รู้จัก ({{type}})",
    "blocks_of": "ชิ้นส่วนของ {{name}}",
    "add_block": "เพิ่มชิ้นส่วน",
    "required": "จำเป็นสำหรับหน้านี้",
    "required_raw": "จำเป็นสำหรับการ์ด raw",
    "required_confirm_title": "ลบ “{{name}}” ไหม?",
    "required_confirm_raw": "การ์ด raw ต้องแสดง Rank (A–D) เสมอ ถ้าไม่มีชิ้นส่วนนี้จะเผยแพร่หน้าสินค้าไม่ได้",
    "required_confirm_body": "หน้านี้ต้องมีชิ้นส่วนนี้ ถ้าไม่มีจะเผยแพร่ไม่ได้",
    "hide_anyway": "ซ่อนอยู่ดี",
    "delete_anyway": "ลบอยู่ดี"
  },
  "reasons": {
    "unknown_type": "ส่วนนี้ใช้ไม่ได้",
    "lives_in_header": "ส่วนนี้อยู่ที่ส่วนหัวของเว็บแล้ว",
    "lives_in_footer": "ส่วนนี้อยู่ที่ส่วนท้ายของเว็บแล้ว",
    "lives_in_overlay": "ส่วนนี้เป็นของหน้าต่างลอย",
    "other_pages_only": "ส่วนนี้ใช้ได้เฉพาะหน้าอื่น",
    "not_in_layout_area": "ส่วนนี้วางในส่วนหัวหรือส่วนท้ายของเว็บไม่ได้",
    "not_on_this_page": "ส่วนนี้ใช้ในหน้านี้ไม่ได้",
    "max_reached_other": "หน้านี้มีส่วนนี้ได้ไม่เกิน {{limit}} อัน",
    "fixed": "ส่วนนี้คือตัวหน้าเอง ซ่อนหรือลบไม่ได้",
    "limit_reached_other": "ชิ้นส่วนนี้ใส่ได้ไม่เกิน {{limit}} อัน",
    "max_blocks": "ส่วนนี้เต็มแล้ว (ชิ้นส่วนไม่เกิน {{limit}} อัน)",
    "no_manifest": "ยังไม่มีรายการส่วนของเว็บ"
  },
  "named_blocks": {
    "rank_indicator": "แสดงระดับสภาพการ์ด Rank A–D (A 美品 · B 軽い傷 · C 傷あり · D ダメージ)",
    "grade_badge": "แสดงบริษัทเกรด เกรด และเลขใบรับรองของการ์ดเกรด",
    "condition_popup": "ลิงก์เปิดคำอธิบายเกณฑ์ Rank",
    "card_details": "เลขการ์ด ชุด ความหายาก และภาษาของการ์ด",
    "trust_notes": "ข้อความสั้นๆ ให้ลูกค้ามั่นใจ: การชำระเงิน การจัดส่ง ของแท้"
  },
  "add": {
    "title": "เพิ่มส่วน",
    "intro": "เลือกสิ่งที่จะเพิ่มในหน้านี้",
    "intro_group": "เลือกสิ่งที่จะเพิ่มใน{{group}}",
    "search": "ค้นหาส่วน",
    "categories": "ประเภทของส่วน",
    "category": {
      "all": "ทั้งหมด",
      "banner": "แบนเนอร์",
      "product": "สินค้า",
      "text": "ข้อความ",
      "media": "รูปและวิดีโอ",
      "other": "อื่นๆ"
    },
    "results": "ส่วนที่เพิ่มได้",
    "no_results": "ไม่มีส่วนที่ตรงกับคำค้น"
  },
  "settings": {
    "title": "ตั้งค่า",
    "pick_something": "คลิกส่วนทางซ้ายหรือในตัวอย่างเพื่อแก้ไข",
    "problems": "จุดที่ต้องแก้",
    "hide_block": "ซ่อนชิ้นส่วนนี้",
    "hide_section": "ซ่อนส่วนนี้",
    "no_settings": "ส่วนนี้ไม่มีอะไรให้ตั้งค่า"
  },
  "fields": {
    "choose": "— เลือก —",
    "pick_color": "เลือกสีของ {{name}}",
    "language": "ภาษา",
    "missing_translation": "ยังไม่มีคำแปล",
    "change": "เปลี่ยน",
    "changed_from_default": "เปลี่ยนจากค่าเริ่มต้น",
    "contrast_low": "อ่านยากบนพื้นนี้ ({{ratio}}:1 — ควรได้ 4.5:1 ขึ้นไป)",
    "contrast_ok": "อ่านง่ายบนพื้นนี้ ({{ratio}}:1)",
    "css_applied": "สิ่งที่เว็บจะใช้ (เฉพาะส่วนนี้):",
    "css_summary": "โค้ดตกแต่ง (ขั้นสูง)",
    "default_option": "ค่าเริ่มต้น ({{value}})",
    "edit_schemes": "แก้ชุดสี",
    "exact_value": "ค่าแน่นอนของ {{name}}",
    "font_samples": "ตัวอย่างตัวอักษร",
    "font_unavailable": "{{font}} (ใช้ไม่ได้แล้ว)",
    "help": "คำอธิบายของ {{name}}",
    "html_preview": "สิ่งที่ลูกค้าจะเห็น",
    "html_removed": "ไม่อนุญาตและถูกเอาออก: {{what}}",
    "icon_none": "ไม่มี",
    "json_broken": "ยังไม่ถูกต้อง — ใช้ค่าล่าสุดที่ถูกต้องไว้ก่อน",
    "json_summary": "ค่าขั้นสูง (JSON)",
    "list_empty": "ยังไม่ได้เลือก",
    "list_full": "เลือกได้ไม่เกิน {{max}} รายการ",
    "media_chosen": "เลือกไฟล์แล้ว",
    "media_placeholder": "รูปตัวอย่าง (เปลี่ยนเป็นรูปของร้าน)",
    "media_none_image": "ยังไม่มีรูป",
    "media_none_video": "ยังไม่มีวิดีโอ",
    "media_none_file": "ยังไม่มีไฟล์",
    "media_pick_image": "เลือกรูป",
    "media_pick_video": "เลือกวิดีโอ",
    "media_pick_file": "เลือกไฟล์",
    "media_change_image": "เปลี่ยนรูป",
    "media_change_video": "เปลี่ยนวิดีโอ",
    "media_change_file": "เปลี่ยนไฟล์",
    "off": "ปิด",
    "on": "เปิด",
    "ref_hint": "พิมพ์ลิงก์แบบ {{kind}}",
    "remove": "เอาออก",
    "remove_item": "เอา {{name}} ออก",
    "required": "ต้องกรอก",
    "scheme_missing": "ไม่มีชุดสี “{{id}}” แล้ว — เลือกชุดอื่น",
    "scheme_name": "ชุดสี {{n}}",
    "unknown_type": "การตั้งค่านี้ ({{type}}) เป็นแบบใหม่ — พิมพ์ค่าอย่างระวัง",
    "video_url_hint": "วางลิงก์ YouTube หรือ Vimeo",
    "pick": {
      "collection": "เลือกหมวดสินค้า",
      "product": "เลือกสินค้า",
      "page": "เลือกหน้า",
      "policy": "เลือกหน้ากฎของร้าน",
      "menu": "เลือกเมนู",
      "attribute": "เลือกข้อมูลสินค้า"
    },
    "add": {
      "collection": "เพิ่มหมวดสินค้า",
      "product": "เพิ่มสินค้า"
    },
    "align": {
      "left": "ชิดซ้าย",
      "center": "กึ่งกลาง",
      "right": "ชิดขวา"
    },
    "media_alt_missing": "รูปนี้ยังไม่มีคำอธิบาย (ยังบันทึกได้)",
    "media_alt_add": "เพิ่มคำอธิบาย",
    "media_alt_missing_other_other": "ยังไม่มีคำอธิบายใน {{count}} ภาษา"
  },
  "preview": {
    "label": "ตัวอย่าง",
    "frame_title": "ตัวอย่างหน้าเว็บ (ร่าง)",
    "loading": "กำลังโหลดตัวอย่าง…",
    "token_failed": "เปิดตัวอย่างไม่ได้",
    "timeout": "ตัวอย่างโหลดไม่ขึ้น",
    "timeout_hint": "ไม่ต้องห่วง การแก้ไขบันทึกเป็นร่างไว้แล้ว ลองใหม่ หรือเปิดตัวอย่างในแท็บใหม่",
    "retry": "ลองใหม่",
    "open_tab": "เปิดในแท็บใหม่"
  },
  "editor": {
    "load_failed": "เปิดหน้าแก้ไขไม่ได้ ลองใหม่อีกครั้ง",
    "no_manifest_title": "ส่วนต่างๆ ของเว็บยังไม่พร้อม",
    "no_manifest_body": "เว็บไซต์ยังไม่ได้ส่งรายการส่วนต่างๆ มา ระบบจะส่งมาเองเมื่อเว็บพร้อม ลองใหม่ภายหลัง",
    "part_load_failed": "โหลด “{{what}}” ไม่ได้"
  },
  "publish": {
    "confirm_title": "เผยแพร่การแก้ไขไหม?",
    "confirm_body": "ลูกค้าจะเห็นหน้าตาใหม่ภายในไม่กี่วินาที ย้อนกลับไปเวอร์ชันก่อนได้ทุกเมื่อ",
    "done": "เผยแพร่แล้ว (เวอร์ชัน {{version}}) เว็บจะเปลี่ยนภายในไม่กี่วินาที",
    "failed": "เผยแพร่ไม่สำเร็จ ตรวจจุดที่มีปัญหาแล้วลองใหม่",
    "unsaved": "มีการแก้ไขที่ยังบันทึกไม่ได้ — แก้ก่อนแล้วค่อยเผยแพร่"
  },
  "leave": {
    "title": "ออกจากหน้าแก้ไขไหม?",
    "body": "มีการแก้ไขที่ยังไม่บันทึก",
    "save_and_leave": "บันทึกแล้วออก",
    "stay": "อยู่ต่อ",
    "switch_title": "เปิดหน้าอื่นไหม?",
    "switch_body": "มีการแก้ไขที่ยังไม่บันทึก บันทึกแล้วเปิด “{{page}}” ไหม?",
    "save_and_switch": "บันทึกแล้วเปิด"
  },
  "conflict": {
    "title": "มีคนอื่นแก้อยู่",
    "body": "“{{what}}” ถูกคนอื่นแก้หลังจากที่คุณเปิด จะโหลดของเขาใหม่ (การแก้ล่าสุดของคุณจะหาย) หรือเขียนทับด้วยของคุณ (การแก้ของเขาจะถูกแทน)?",
    "reload": "โหลดใหม่",
    "overwrite": "เขียนทับ"
  },
  "toast": {
    "section_removed": "ลบ “{{name}}” แล้ว",
    "block_removed": "ลบ “{{name}}” แล้ว",
    "undo": "เลิกทำ"
  },
  "narrow": {
    "title": "เปิดบนคอมพิวเตอร์/แท็บเล็ตแนวนอนเพื่อแก้หน้าเว็บ",
    "body": "การแก้หน้าตาเว็บต้องใช้จอที่กว้างกว่านี้ ส่วนหน้าข้อมูล เมนู และประกาศ ยังแก้บนมือถือได้",
    "content": "แก้หน้าและเมนู",
    "back": "กลับไปหน้าตาเว็บไซต์"
  },
  "issues": {
    "generic": "มีจุดที่ต้องตรวจสอบ",
    "required_missing": "จำเป็น: {{setting}} ยังว่างอยู่",
    "media_missing": "รูปยังไม่เลือก — เลือกรูปก่อน",
    "media_unverified": "ยังตรวจรูปไม่ได้",
    "unknown_section_type": "เว็บไม่มีส่วนนี้แล้ว",
    "unknown_block_type": "เว็บไม่มีชิ้นส่วนนี้แล้ว",
    "section_not_allowed_here": "ส่วนนี้ใช้ตรงนี้ไม่ได้",
    "too_many_sections_of_type": "ส่วนนี้ในหน้ามีมากเกินไป",
    "too_many_sections": "หน้านี้มีส่วนมากเกินไป",
    "too_many_blocks": "ส่วนนี้มีชิ้นส่วนมากเกินไป",
    "block_limit_exceeded": "ชิ้นส่วนนี้มีมากเกินไป",
    "required_block_missing": "ขาดชิ้นส่วนที่จำเป็น (เช่น Rank ในหน้าสินค้า)",
    "invalid_value": "{{setting}} มีค่าที่ใช้ไม่ได้",
    "invalid_ref": "{{setting}} ลิงก์ไปที่ไม่ถูกต้อง",
    "invalid_ref_kind": "{{setting}} ลิงก์ผิดประเภท",
    "ref_not_found": "{{setting}} ลิงก์ไปสิ่งที่ไม่มี (แล้ว)",
    "ref_not_published": "{{setting}} ลิงก์ไปสิ่งที่ยังไม่เผยแพร่",
    "unsafe_html": "ข้อความมีโค้ดที่ไม่อนุญาต",
    "html_cleaned": "ตัดรูปแบบข้อความที่เว็บไม่รองรับออกแล้ว",
    "unsafe_css": "โค้ดสไตล์มีสิ่งที่ไม่อนุญาต",
    "unknown_setting": "การตั้งค่าเก่า ({{setting}}) ไม่ได้ใช้แล้ว",
    "unknown_locale": "มีข้อความในภาษาที่ร้านไม่ได้ใช้",
    "low_contrast": "สีตัวอักษรกับพื้นหลังอ่านยาก",
    "font_not_allowed": "ใช้ฟอนต์นี้ไม่ได้",
    "unknown_color_scheme": "ไม่มีชุดสีนี้",
    "section_not_in_order": "มีส่วนที่บันทึกไว้แต่ไม่แสดงบนหน้า",
    "manifest_missing": "ยังไม่มีรายการส่วนของเว็บ",
    "color_required": "ชุดสีขาดสีบางอย่าง",
    "invalid_color": "เขียนสีไม่ถูก (ใช้ #RRGGBB)",
    "duplicate_color_scheme_id": "มีชุดสีชื่อซ้ำกัน",
    "color_schemes_required": "ต้องมีชุดสีอย่างน้อย 1 ชุด",
    "liquid_syntax": "โค้ดข้อมูลสินค้าในข้อความเขียนไม่ถูก",
    "liquid_forbidden_tag": "ข้อความใช้โค้ดที่ไม่อนุญาต",
    "template_missing": "มีหน้าบางแบบที่ยังไม่มีหน้าตา — หน้าเหล่านั้นจะแสดง “ไม่พบหน้า”"
  },
  "picker": {
    "description": "ค้นหาแล้วคลิกอันที่ต้องการ",
    "empty": "ไม่พบรายการ",
    "failed": "ค้นหาไม่ได้ตอนนี้ ลองใหม่อีกครั้ง",
    "results": "ผลการค้นหา",
    "search": "ค้นหา",
    "products_count_one": "{{count}} สินค้า",
    "products_count_other": "{{count}} สินค้า",
    "links_count_one": "{{count}} ลิงก์",
    "links_count_other": "{{count}} ลิงก์",
    "status": {
      "active": "วางขายอยู่",
      "draft": "ยังไม่วางขาย",
      "archived": "เก็บเข้าคลัง",
      "sold_out": "ขายหมดแล้ว",
      "published": "เผยแพร่แล้ว",
      "scheduled": "ตั้งเวลาไว้",
      "trashed": "อยู่ในถังขยะ",
      "ready": "พร้อมใช้",
      "processing": "กำลังเตรียมไฟล์"
    }
  },
  "link": {
    "goes_to": "ลิงก์ไปที่",
    "filter_advanced": "ตัวกรอง (ขั้นสูง)",
    "only_rank": "เฉพาะการ์ด Rank",
    "rank": "Rank {{rank}}",
    "search_placeholder": "คำที่จะค้น เช่น pikachu",
    "target": {
      "collection": "หมวดสินค้า",
      "product": "สินค้า",
      "page": "หน้าข้อมูล",
      "policy": "หน้ากฎของร้าน",
      "search": "ผลการค้นหา",
      "url": "ที่อยู่อื่น",
      "filtered": "หมวดสินค้าแบบกรอง"
    }
  },
  "liquid": {
    "insert_button": "แทรกข้อมูลสินค้า",
    "insert": {
      "product_title": "ชื่อสินค้า",
      "product_price": "ราคา",
      "product_rank": "Rank (A–D)",
      "product_grade": "เกรด (การ์ดเกรด)",
      "product_set": "ชื่อชุด",
      "product_number": "เลขการ์ด",
      "collection_title": "ชื่อหมวด",
      "shop_name": "ชื่อร้าน"
    }
  },
  "translate": {
    "auto": "แปลอัตโนมัติ",
    "copy_all_from_en": "คัดลอกภาษาอังกฤษใส่ทุกช่องที่ว่าง",
    "copy_from_en": "คัดลอกจากอังกฤษ",
    "copied_mark": "คัดลอกมา — ควรตรวจ",
    "machine_mark": "แปลโดยเครื่อง — ควรตรวจ",
    "editing_language": "กำลังแก้: {{language}}",
    "failed": "แปลไม่สำเร็จ ลองใหม่หรือพิมพ์เอง",
    "not_enabled": "ยังไม่ได้เปิดใช้การแปลอัตโนมัติ กรุณาพิมพ์เองหรือคัดลอกจากภาษาอังกฤษ",
    "working": "กำลังแปล…"
  },
  "richtext": {
    "bold": "ตัวหนา",
    "bullets": "รายการแบบจุด",
    "italic": "ตัวเอียง",
    "link": "ใส่ลิงก์",
    "link_address": "ที่อยู่ลิงก์",
    "link_apply": "ใส่ลิงก์",
    "numbers": "รายการแบบตัวเลข",
    "toolbar": "รูปแบบข้อความของ {{name}}",
    "unlink": "เอาลิงก์ออก"
  },
  "validation": {
    "invalid": "ค่านี้ใช้ไม่ได้",
    "required": "กรุณากรอกช่องนี้",
    "maxLength": "ยาวเกินไป — ไม่เกิน {{limit}} ตัวอักษร",
    "minLength": "สั้นเกินไป — อย่างน้อย {{limit}} ตัวอักษร",
    "maximum": "ไม่เกิน {{limit}}",
    "minimum": "อย่างน้อย {{limit}}",
    "exclusiveMaximum": "ต้องน้อยกว่า {{limit}}",
    "exclusiveMinimum": "ต้องมากกว่า {{limit}}",
    "maxItems": "ไม่เกิน {{limit}} รายการ",
    "minItems": "อย่างน้อย {{limit}} รายการ",
    "multipleOf": "ต้องเป็นทวีคูณของ {{limit}}",
    "enum": "กรุณาเลือกจากรายการ",
    "type": "ใส่ค่าแบบนี้ที่นี่ไม่ได้",
    "pattern": "รูปแบบไม่ถูกต้อง",
    "uniqueItems": "เลือกรายการเดียวกันซ้ำ",
    "bad_link": "ลิงก์นี้ใช้ไม่ได้",
    "wrong_kind": "ชี้ไปผิดประเภท ({{kind}})",
    "liquid_syntax": "โค้ดข้อมูลสินค้าเขียนไม่ถูก ({{detail}})",
    "liquid_forbidden_tag": "ใช้ “{{detail}}” ที่นี่ไม่ได้",
    "liquid_unknown_variable": "ไม่รู้จัก {{detail}}",
    "liquid_unknown_filter": "ไม่รู้จักรูปแบบ {{detail}}",
    "css_backslash": "ห้ามใช้เครื่องหมาย \\ ในโค้ดตกแต่ง",
    "css_style_tag": "ห้ามใช้ “</style”",
    "css_script_url": "ห้ามใช้ลิงก์ javascript:",
    "css_expression": "ห้ามใช้ expression()",
    "css_comment_open": "หมายเหตุ /* … */ ไม่ได้ปิด",
    "css_quote_open": "ข้อความในเครื่องหมายคำพูดไม่ได้ปิด",
    "css_outside_url": "รูปและลิงก์ต้องมาจากร้านนี้เท่านั้น (ที่อยู่ขึ้นต้นด้วย /)",
    "css_at_rule": "ห้ามใช้ {{detail}} ในโค้ดตกแต่ง",
    "css_attr_in_url": "ใช้ attr() ใน url() ไม่ได้",
    "css_url_open": "url( ไม่ได้ปิด",
    "css_url_malformed": "เขียน url() ไม่ถูก",
    "css_forbidden": "ห้ามใช้ {{detail}}"
  },
  "schemes": {
    "add": "เพิ่มชุดสี",
    "contrast_button": "ตัวอักษรบนปุ่ม",
    "contrast_text": "ตัวอักษรบนพื้น",
    "duplicate": "ทำสำเนา {{name}}",
    "in_use_one": "ใช้อยู่ที่ {{count}} ส่วน",
    "in_use_other": "ใช้อยู่ที่ {{count}} ส่วน",
    "last_one": "เว็บต้องมีชุดสีอย่างน้อย 1 ชุด",
    "list": "ชุดสี",
    "ratio_low": "{{ratio}}:1 — อ่านยาก",
    "ratio_ok": "{{ratio}}:1 — อ่านง่าย",
    "remove": "ลบ {{name}}",
    "sample_button": "ใส่ตะกร้า",
    "sample_heading": "Pikachu ex — Rank A",
    "sample_secondary": "พื้นรอง",
    "sample_text": "ส่งจากญี่ปุ่นภายใน 2–3 วัน",
    "show_uses": "(ดู)",
    "role": {
      "background": "พื้นหลัง",
      "text": "ตัวอักษร",
      "accent": "ปุ่ม",
      "accent_contrast": "ตัวอักษรบนปุ่ม",
      "secondary": "พื้นรอง"
    }
  },
  "theme_settings": {
    "title": "ตั้งค่าทั้งเว็บ",
    "group": {
      "localization": "ภาษา"
    },
    "localization_body": "ภาษาที่เว็บแสดงและการพาลูกค้าไปหน้าภาษาของเขา ตั้งที่หน้าจอ “ภาษา” ส่วนสกุลเงินและประเทศอยู่ที่หน้าจอ “ตลาด”",
    "migrate": "อัปเดตการตั้งค่า",
    "migrate_failed": "อัปเดตไม่สำเร็จ ลองใหม่อีกครั้ง",
    "migrating": "กำลังอัปเดต…",
    "migration_body": "เว็บมีการตั้งค่าใหม่ กดอัปเดตเพื่อให้เห็น — ค่าที่ตั้งไว้ยังอยู่ครบ",
    "migration_title": "มีการตั้งค่าใหม่ให้เลือก",
    "open_localization": "เปิดหน้าภาษา",
    "open_markets": "เปิดหน้าตลาด",
    "markets_not_ready": "หน้าจอ “ตลาด” (สกุลเงินและประเทศ) ยังไม่พร้อม — จะมาพร้อมการอัปเดตเรื่องตลาด",
    "recommended_size": "ขนาดที่แนะนำ: {{size}} px",
    "reset": "รีเซ็ตเป็นค่าเริ่มต้น",
    "reset_body": "การตั้งค่าทุกอย่างในกลุ่มนี้จะกลับเป็นค่าเริ่มต้น กดย้อนกลับได้",
    "reset_title": "รีเซ็ต “{{group}}” ไหม?"
  },
  "typography": {
    "preview": "ตัวอย่างตัวอักษร"
  },
  "diff": {
    "added": "เพิ่ม: {{names}}",
    "headline_one": "เปลี่ยน {{count}} อย่าง:",
    "headline_other": "เปลี่ยน {{count}} อย่าง:",
    "nothing": "ยังไม่มีอะไรต่างจากที่อยู่บนเว็บ",
    "page_added": "หน้าใหม่",
    "page_removed": "ลบหน้า",
    "removed": "เอาออก: {{names}}",
    "reordered": "เรียงลำดับใหม่",
    "whole_website": "ตั้งค่าทั้งเว็บ",
    "marker": {
      "type": "ชนิดของส่วน",
      "disabled": "ซ่อน/แสดง",
      "blocks": "ชิ้นส่วน",
      "block_order": "ลำดับชิ้นส่วน"
    }
  },
  "publish_dialog": {
    "blocked_now": "ต้องแก้บางอย่างก่อน — ดูรายการ",
    "check_failed": "ตรวจไม่สำเร็จ ลองใหม่อีกครั้ง",
    "checking": "กำลังบันทึกและตรวจการแก้ไข…",
    "errors_one": "ต้องแก้ {{count}} อย่างก่อนเผยแพร่",
    "errors_other": "ต้องแก้ {{count}} อย่างก่อนเผยแพร่",
    "fix": "ไปแก้",
    "later": "ตั้งเวลา",
    "note": "บันทึกช่วยจำ (ไม่บังคับ)",
    "note_placeholder": "เช่น แบนเนอร์ฤดูใบไม้ร่วง",
    "now": "เผยแพร่เดี๋ยวนี้",
    "policy_missing": "หน้ากฎของร้าน (特定商取引法に基づく表記) ยังไม่ครบ",
    "publish_now": "เผยแพร่เดี๋ยวนี้",
    "request_body": "เฉพาะเจ้าของหรือผู้จัดการที่เผยแพร่ขึ้นเว็บได้ ตรวจสิ่งที่เปลี่ยนแล้วส่งให้เขา",
    "request_button": "ส่งให้ผู้จัดการ",
    "request_failed": "ส่งไม่สำเร็จ ลองใหม่อีกครั้ง",
    "request_heading": "ส่งให้ผู้จัดการเผยแพร่",
    "request_manual": "บอกผู้จัดการ: เปิด “หน้าตาเว็บไซต์” แล้วกดเผยแพร่",
    "request_sent": "ส่งแล้ว — ผู้จัดการจะเห็นในรายการงาน",
    "request_title": "ช่วยเผยแพร่หน้าตาเว็บ “{{theme}}”",
    "schedule_button": "ตั้งเวลาเผยแพร่",
    "time_label": "วันและเวลา (เวลาญี่ปุ่น)",
    "time_past": "กรุณาเลือกเวลาในอนาคต",
    "title": "เผยแพร่การแก้ไข",
    "warnings_one": "มี {{count}} อย่างที่ควรตรวจ (ยังเผยแพร่ได้)",
    "warnings_other": "มี {{count}} อย่างที่ควรตรวจ (ยังเผยแพร่ได้)",
    "when": "เมื่อไร"
  },
  "publish_result": {
    "cancel_schedule": "ยกเลิก",
    "done": "เผยแพร่แล้ว (เวอร์ชัน {{version}}) — เว็บจะอัปเดตภายในไม่กี่วินาที",
    "not_updated": "เว็บอาจยังไม่อัปเดต",
    "schedule_cancel_failed": "ยกเลิกไม่สำเร็จ ลองใหม่อีกครั้ง",
    "schedule_cancelled": "ยกเลิกการตั้งเวลาเผยแพร่แล้ว",
    "schedule_failed": "เผยแพร่ตามเวลาที่ตั้งไม่สำเร็จ กรุณาเผยแพร่อีกครั้ง",
    "scheduled": "ตั้งเวลาแล้ว — จะเผยแพร่ {{when}} (เวลาญี่ปุ่น)",
    "scheduled_bar": "จะเผยแพร่ {{when}} (เวลาญี่ปุ่น)",
    "unknown": "เผยแพร่แล้ว เปิดเว็บเพื่อตรวจดู",
    "updated": "เว็บอัปเดตแล้ว",
    "updating": "กำลังอัปเดตเว็บ…",
    "view_site": "ดูเว็บ"
  },
  "versions": {
    "back_to_editor": "กลับไปหน้าแก้",
    "compare": "ต่างจากร่างตรงไหน",
    "compare_intro": "สิ่งที่ร่างตอนนี้ต่างจากเวอร์ชันนี้:",
    "empty": "ยังไม่เคยเผยแพร่",
    "intro": "ทุกครั้งที่เอาหน้าตาเว็บขึ้นเว็บ",
    "load_failed": "โหลดประวัติไม่ได้ ลองใหม่อีกครั้ง",
    "restore_draft": "นำมาเป็นร่างด้วย",
    "restore_draft_hint": "ร่างที่แก้อยู่จะถูกแทนด้วยเวอร์ชันนี้ ถ้าไม่ติ๊ก ร่างของคุณยังอยู่เหมือนเดิม",
    "rollback": "ย้อนกลับไปเวอร์ชันนี้",
    "rollback_body": "ลูกค้าจะเห็นเวอร์ชันนี้อีกครั้งภายในไม่กี่วินาที",
    "rollback_confirm": "ย้อนกลับ",
    "rollback_failed": "ย้อนกลับไม่สำเร็จ ลองใหม่อีกครั้ง",
    "rollback_title": "ย้อนกลับไปเวอร์ชัน {{version}} ไหม?",
    "rolled_back": "เว็บกลับไปใช้เวอร์ชัน {{version}} แล้ว",
    "title": "ประวัติการเผยแพร่",
    "version": "เวอร์ชัน {{version}}",
    "reason": {
      "publish": "เผยแพร่",
      "rollback": "ย้อนกลับ",
      "scheduled": "ตั้งเวลา",
      "seed": "ตั้งต้นระบบ",
      "import": "นำเข้า"
    }
  },
  "icons": {
    "truck": "จัดส่ง",
    "package": "พัสดุ",
    "box": "กล่อง",
    "shield": "คุ้มครอง",
    "badge-check": "ตรวจแล้ว",
    "star": "ดาว",
    "sparkles": "ใหม่",
    "heart": "ชอบ",
    "gift": "ของขวัญ",
    "credit-card": "ชำระเงิน",
    "rotate-ccw": "คืนสินค้า",
    "map-pin": "สถานที่",
    "store": "ร้าน",
    "shopping-bag": "ถุง",
    "message-circle": "ข้อความ"
  },
  "tour": {
    "open": "วิธีใช้หน้าแก้ไข (แนะนำสั้น ๆ)",
    "progress": "ขั้นที่ {{step}} จาก {{total}}",
    "close": "ปิดคำแนะนำ",
    "skip": "ข้ามไปก่อน",
    "back": "ย้อน",
    "next": "ถัดไป",
    "done": "เข้าใจแล้ว",
    "select": {
      "title": "1. เลือกส่วนที่จะแก้",
      "body": "กดชื่อส่วนในรายการด้านซ้าย หรือกดบนหน้าเว็บตรงกลางได้เลย เช่น แบนเนอร์ใหญ่ด้านบน"
    },
    "edit": {
      "title": "2. เปลี่ยนรูปหรือข้อความ",
      "body": "ช่องด้านขวาใช้แก้ส่วนที่เลือก กด \"เปลี่ยนรูป\" หรือพิมพ์ข้อความใหม่ ระบบบันทึกเป็นร่างให้เอง"
    },
    "mobile": {
      "title": "3. ดูบนมือถือ",
      "body": "กดปุ่มมือถือเพื่อดูว่าบนโทรศัพท์หน้าตาเป็นอย่างไร ลูกค้าส่วนใหญ่ซื้อผ่านมือถือ"
    },
    "publish": {
      "title": "4. เผยแพร่ขึ้นเว็บ",
      "body": "พอใจแล้วกด \"เผยแพร่\" ลูกค้าจะเห็นภายในไม่กี่วินาที",
      "body_request": "พอใจแล้วกด \"ส่งให้ผู้จัดการเผยแพร่\" ผู้จัดการจะเอาขึ้นเว็บให้"
    },
    "undo": {
      "title": "5. ย้อนกลับได้เสมอ",
      "body": "แก้ผิดกด ย้อนกลับ (⌘Z / Ctrl+Z) ส่วนปุ่ม \"ประวัติ\" เอาเว็บกลับไปเป็นแบบเดิมได้ใน 2 คลิก"
    }
  },
  "live": {
    "bar": "“{{what}}” ถูกแก้โดย {{name}} ระหว่างที่คุณแก้อยู่",
    "someone": "คนอื่น",
    "bar_hint": "ถ้าโหลดฉบับของเขา สิ่งที่คุณแก้ในส่วนนี้และยังไม่ได้บันทึกจะหายไป",
    "load": "โหลดฉบับของเขา",
    "compare": "เปรียบเทียบ",
    "followed": "“{{what}}” แสดงการแก้ที่ {{name}} บันทึกแล้ว",
    "diff_title": "สิ่งที่ต่างกันใน “{{what}}”",
    "diff_intro": "เทียบฉบับของคุณในหน้านี้กับฉบับที่ {{name}} บันทึก",
    "diff_only_theirs": "มีเฉพาะในฉบับของเขา: {{name}}",
    "diff_only_mine": "มีเฉพาะในฉบับของคุณ: {{name}}",
    "diff_changed": "{{name}} ต่างกัน: {{fields}}",
    "diff_blocks": "รายการข้างใน",
    "diff_visibility": "แสดง / ซ่อน",
    "diff_order": "ลำดับของส่วนต่างๆ ไม่เหมือนกัน",
    "diff_settings": "การตั้งค่าที่ต่างกัน: {{fields}}",
    "diff_same": "ไม่มีส่วนที่ต่างกัน ทั้งสองฉบับเหมือนกัน",
    "diff_loading": "กำลังโหลดฉบับของเขา…",
    "diff_failed": "โหลดฉบับของเขาไม่ได้ กรุณาลองอีกครั้ง",
    "use_theirs": "ใช้ฉบับของเขา",
    "keep_mine": "บันทึกฉบับของฉัน",
    "close": "ปิด"
  }
}
